import { forwardRef } from "react";
import { InputBase, styled, InputBaseProps } from "@mui/material";

import { BORDER_COLORS } from "../../constants";

interface ITextFieldProps extends InputBaseProps {
  autoSelect?: boolean;
  textAlign?: "left" | "right" | "center";
}

const BootstrapInput = styled(
  ({ textAlign, ...props }: Omit<ITextFieldProps, "autoSelect">) => (
    <InputBase {...props} />
  ),
)(({ textAlign = "left" }) => ({
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: "#FFFFFF",
    border: "1px solid",
    borderColor: BORDER_COLORS.default,
    fontSize: 16,
    fontWeight: 400,
    width: "100%",
    boxShadow: "none",
    height: "32px",
    padding: "2px 4px",
    textAlign: textAlign,
    // transition: theme.transitions.create(["border-color", "background-color"]),
    boxSizing: "border-box",
    "&:focus": {
      borderColor: BORDER_COLORS.focused,
    },
  },
}));

export const TextField = forwardRef<HTMLInputElement, ITextFieldProps>(
  ({ autoSelect, ...props }, ref) => {
    const handleFocus = (event: React.FocusEvent<HTMLInputElement>) => {
      if (autoSelect) event.target.select();
      props.onFocus?.(event);
    };

    return <BootstrapInput {...props} onFocus={handleFocus} ref={ref} />;
  },
);

export default TextField;
